
import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { environment } from '../../../environments/environment';

import { AppService } from '../../Services/app.service';



import { VerticalNavClientComponent } from '../navigation/vertical-nav-client/vertical-nav-client.component';

@Component({
    selector: 'app-dashboard-client-admin',
    templateUrl: './dashboard-client-admin.component.html',
    styleUrls: ['./dashboard-client-admin.component.scss'],
    imports: [
    VerticalNavClientComponent,
    RouterOutlet
]
})
export class DashboardClientAdminComponent implements OnInit {
  title = environment.appName;
  constructor(public appS: AppService) {}

  ngOnInit(): void {}
}
